import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import { IS_WORKSPACE_ADMIN } from "common/ComponentAccess";
import { me } from "constants/Client";
import { useDispatch } from "react-redux";
import { setLeftNavState } from "store/actions";
import useAccess from "hooks/useAccess";

const SidebarContent = props => {
  const {
    dashboard,
    service,
    participant,
    employee,
    calendar,
    companyPolicy,
    location,
    noticeBoard,
    report,
    invoice,
    email,
    task,
    shift,
    template,
    medication,
    hazardReport,
    trainingLinks,
    openShift,
    incidentReport,
    vehicleRegister,
    riskAssessment,
    notesTemplate,
    feedback,
  } = useAccess();

  const dispatch = useDispatch();
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (props.location.pathname.includes(items[i].pathname)) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  const setNavState = () => {
    if (document.body.classList.contains("vertical-collpsed")) {
      dispatch(setLeftNavState(true));
    }
  };

  return (
    <React.Fragment>
      <SimpleBar className='h-100' ref={ref}>
        <div id='sidebar-menu'>
          <ul className='metismenu list-unstyled' id='side-menu'>
            {/* Dashboard */}
            {dashboard?.view && (
              <li>
                <Link onClick={setNavState} to='/dashboard'>
                  <i className='bx bx-home-circle me-2'></i>
                  <span>{props.t("Dashboard")}</span>
                </Link>
              </li>
            )}
            {/* Dashboard */}
            {/* Service */}
            {service?.view && (
              <li>
                <Link onClick={setNavState} to='/service-list'>
                  <i className='bx bx-briefcase-alt-2 me-2'></i>
                  <span>{props.t("Service")}</span>
                </Link>
              </li>
            )}
            {/* Service */}
            {/* Participant */}
            {participant?.view && (
              <li>
                <Link onClick={setNavState} to='/client-list'>
                  <i className='bx bx-user me-2'></i>
                  <span>{props.t("Participant")}</span>
                </Link>
              </li>
            )}
            {/* Participant */}
            {/* Login As */}
            {/* {loginAs?.view && (
              <li>
                <Link onClick={setNavState} to='/admins' className='has-arrow'>
                  <i className='mdi mdi-account-arrow-right-outline me-2' />
                  <span>{props.t('Login As')}</span>
                </Link>
                <ul className='sub-menu'>
                  <li>
                    {loginAs && isEmpty(me()?.manager_id) && (
                      <Link onClick={setNavState} to='/admins'>
                        {props.t('Admin')}
                      </Link>
                    )}
                  </li>
                  <li>
                      <Link onClick={setNavState} to='/managers-list'>
                        {props.t('Manager')}
                      </Link>
                  </li>
                </ul>
              </li>
            )} */}
            {/* Login As */}

            {/* Employee */}
            {employee?.view && (
              <li>
                <Link onClick={setNavState} to='/staff-list' className='has-arrow'>
                  <i className='bx bx-user-circle me-2' />
                  <span>{props.t("Employees")}</span>
                </Link>
                <ul className='sub-menu'>
                  <li>
                    <Link onClick={setNavState} to='/staff-list'>
                      {props.t("Employees List")}
                    </Link>
                  </li>
                  {employee?.extra?.employeesExpireDocuments && (
                    <li>
                      <Link onClick={setNavState} to='/pending-docs'>
                        {props.t("Expiring Documents")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {/* Employee */}

            {/* Calender */}
            {calendar?.view && (
              <li>
                <Link onClick={setNavState} to='/calender'>
                  <i className='mdi mdi-calendar-month-outline me-2'></i>
                  <span>{props.t("Calender")}</span>
                </Link>
              </li>
            )}
            {/* Calender */}

            {/* Tasks */}
            {[task?.view, shift?.view, openShift?.view].some(_ => _) && (
              <li>
                <Link onClick={setNavState} to='/task-list' className='has-arrow'>
                  <i className='bx bx-task me-2' />
                  <span>{props.t("Shift Roster")}</span>
                </Link>
                <ul className='sub-menu'>
                  {task?.view && (
                    <li>
                      <Link onClick={setNavState} to='/task-list'>
                        {props.t("Tasks List")}
                      </Link>
                    </li>
                  )}
                  {!IS_WORKSPACE_ADMIN() && (
                    <>
                      <li>
                        <Link onClick={setNavState} to='/my-task'>
                          {props.t("My Tasks")}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={setNavState} to='/my-shift'>
                          {props.t("My Shifts")}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={setNavState} to='/my-complaint'>
                          {props.t("My Feedback")}
                        </Link>
                      </li>
                    </>
                  )}
                  {shift?.view && (
                    <li>
                      <Link onClick={setNavState} to='/shift'>
                        {props.t("Shift Roster")}
                      </Link>
                    </li>
                  )}
                  {openShift?.view && (
                    <li>
                      <Link onClick={setNavState} to='/open-shift'>
                        {props.t("Open Shifts")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {/* Tasks */}

            {/* Register */}
            {[
              hazardReport?.view,
              medication?.view,
              template?.view,
              riskAssessment?.view,
              vehicleRegister?.view,
              incidentReport?.view,
              notesTemplate?.view,
            ].some(_ => _) && (
              <li>
                <Link onClick={setNavState} to='/registers' className='has-arrow'>
                  <i className='bx bx-book-bookmark me-2' />
                  <span>{props.t("Register")}</span>
                </Link>
                <ul className='sub-menu'>
                  {incidentReport?.view && (
                    <li>
                      <Link onClick={setNavState} to='/registers'>
                        {props.t("Incident Reports")}
                      </Link>
                    </li>
                  )}
                  {hazardReport?.view && (
                    <li>
                      <Link onClick={setNavState} to='/hazard-report'>
                        {props.t("Hazard Reports")}
                      </Link>
                    </li>
                  )}
                  {vehicleRegister?.view && (
                    <li>
                      <Link onClick={setNavState} to='/vehicle-list'>
                        {props.t("Vehicles Register")}
                      </Link>
                    </li>
                  )}
                  {riskAssessment?.view && (
                    <li>
                      <Link onClick={setNavState} to='/risk-assesement'>
                        {props.t("Risk Assessment")}
                      </Link>
                    </li>
                  )}
                  {template?.view && (
                    <li>
                      <Link onClick={setNavState} to='/template'>
                        {props.t("Template")}
                      </Link>
                    </li>
                  )}
                  {medication?.view && (
                    <li>
                      <Link onClick={setNavState} to='/medication'>
                        {props.t("Medication")}
                      </Link>
                    </li>
                  )}
                  {notesTemplate?.view && (
                    <li>
                      <Link onClick={setNavState} to='/pn-template'>
                        {props.t("Notes Template")}
                      </Link>
                    </li>
                  )}
                  {feedback?.view && (
                    <li>
                      <Link onClick={setNavState} to='/complaints'>
                        {props.t("Feedback")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {/* Register */}

            {/* Links */}
            {[companyPolicy?.view, trainingLinks?.view].some(_ => _) && (
              <li>
                <Link onClick={setNavState} to='/training-links' className='has-arrow'>
                  <i className='bx bx-link me-2' />
                  <span>{props.t("Training & Policy")}</span>
                </Link>
                <ul className='sub-menu'>
                  {trainingLinks?.view && (
                    <li>
                      <Link onClick={setNavState} to='/training-links'>
                        {props.t("Training Links")}
                      </Link>
                    </li>
                  )}
                  {companyPolicy?.view && (
                    <li>
                      <Link onClick={setNavState} to='/privacy-policy'>
                        {props.t(`${me()?.company_name} Policy`)}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {/* Links */}

            {/* Invoice */}
            {invoice?.view && (
              <li>
                <Link onClick={setNavState} to='/invoice'>
                  <i className='bx bx-receipt me-2' />
                  <span>{props.t("Invoice")}</span>
                </Link>
              </li>
            )}
            {/* Invoice */}

            {/* Email */}
            {email?.view && (
              <li>
                <Link onClick={setNavState} to='/email-inbox'>
                  <i className='bx bx-mail-send me-2' />
                  <span>{props.t("Email")}</span>
                </Link>
              </li>
            )}
            {/* Email */}
            {/* NoticeBoard */}
            {noticeBoard?.view && (
              <li>
                <Link onClick={setNavState} to='/notice-board'>
                  <i className='bx bx-chalkboard me-2' />
                  <span>{props.t("Notice Board")}</span>
                </Link>
              </li>
            )}
            {/* NoticeBoard */}
            {/* Report (chat-gpt) */}
            {report?.view && (
              <li>
                <Link onClick={setNavState} to='/participant-task-report'>
                  <i className='mdi mdi-file-chart-outline me-2' />
                  <span>{props.t("Report")}</span>
                </Link>
              </li>
            )}
            {/* Report (chat-gpt) */}
            {/* Location */}
            {location?.view && (
              <li>
                <Link onClick={setNavState} to='/location'>
                  <i className='bx bx-map-pin me-2' />
                  <span>{props.t("Location")}</span>
                </Link>
              </li>
            )}
            {/* Location */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
